<toaster-container [toasterconfig]="config"></toaster-container>
<block-ui>
    <app-header *ngIf="globals.logado"></app-header>
    <div class="conteudo">
        <router-outlet></router-outlet>
    </div>
</block-ui>